import React, { useCallback, useEffect, useState } from "react";
import { notBlank } from "../../../util/ext";

import Container from "@material-ui/core/Container";
import { useParams } from "react-router-dom";
import ModuleAdminEditDialog from "./ModuleAdminEditDialog";

const ModuleEdit = props => {
  const { view, onCancel } = props;
  const { id } = useParams();
  const [editVisible, setEditVisible] = useState(false);

  const handleCancel = useCallback(() => {
    setEditVisible(false);
    onCancel();
  }, [onCancel]);

  useEffect(() => {
    if (notBlank(id)) {
      setEditVisible(true);
    } else {
      setEditVisible(false);
    }
  }, [id]);

  return (
    <Container>
      <ModuleAdminEditDialog
        id={id}
        view={view}
        visible={editVisible}
        onCancel={handleCancel}
      />
    </Container>
  );
};

export default ModuleEdit;
